// extracted by mini-css-extract-plugin
export var panelWrapper = "ConsentItem-module--panelWrapper--155d1";
export var panel = "ConsentItem-module--panel--71708";
export var description = "ConsentItem-module--description--7e6ea";
export var active = "ConsentItem-module--active--bea68";
export var title = "ConsentItem-module--title--8b19a";
export var panelContentWrapper = "ConsentItem-module--panelContentWrapper--27f9e";
export var replaceText = "ConsentItem-module--replaceText--09ddd";